module.exports = __webpack_public_path__ + "static/media/Qayyum.f35c7ce3.jpg";